module.exports = __webpack_public_path__ + "img/horizontal.4def9f08.svg";